export default {
	loading: {
		partIsLoading: "Loading part...",
		partIsSaving: "Saving part...",
		anchorFaceIsChanging: "Changing top side...",
		featureIsSetting: "Applying feature...",
		whileMarkingFeaturesMessage: "Marking features...",
		imageAlt: "Loading...",
	},
	errors: {
		modelCannotBeShown: "The model cannot be displayed. Please contact our helpdesk.",
		saveFailedTitle: "Error while saving",
		changeCouldNotBeMade: "The change could not be made. Please contact our helpdesk.",
		messageCouldNotBeConfirmed: "The message could not be confirmed.",
		weldlineDefinitionError: "Error defining the weld seams. Please contact info@blexon.com",
		modificationFailedShortDescription:
			"The requested modification of the model could not be completed. " +
			"Please send the article to our helpdesk for a free review.",
		featureCreationFailedTitle: "Feature could not be created",
		editingErrorTitle: "Error while editing",
		modelEditingFailedTitle: "Error while editing the model",
		rollDirectionAdjustFailedTitle: "Roll direction could not be adjusted",
		rollDirectionAngleAdjustFailedTitle: "Roll direction angle could not be adjusted",
		rollDirectionSetFailed:
			"Roll direction could not be set. Please use a line on an outer contour or a cutout.",
	},
	devMode: "DEV-MODE",
	panels: {
		editor: "Editor",
		mode: "Mode",
		article: "Article",
		messages: "Messages",
		features: "Features",
		structure: "Structure",
	},
	processType: {
		cut: "Cutting",
		cylindicBend: "Bend",
		engrave: "Engraving",
		formCountersink: "Countersink",
		formExtrudedThread: "Extruded thread",
		formScrewThread: "Thread forming",
		weld: "Welding",
		drillCylinderHeadBoltHole: "Cylinder head counterbore",
		pressJoin: "Press joint",
		none: "No process",
		unknown: "Unknown process",
	},
	editorMode: {
		featureMode: "Editing",
		measuringMode: "Measuring",
		rollDirectionMode: "Roll direction",
		weldMode: "Welding",
		none: "No mode",
	},
	featureType: {
		undefined: "Undefined",
		anchorFace: "Top side",
		bottomFace: "Bottom side",
		sideFace: "Outer side",
		bend: "Bend line",
		hole: "Round hole",
		cutout: "Cutout",
		screwThread: "Thread",
		countersink: "Countersink",
		extrudedThread: "Extruded collar",
		engraving: "Engraving",
		invalid: "Invalid",
		weldline: "Weld seam",
		cylinderHeadBoltHole: "Weld seam",
		pressJoin: "Press joint",
		unknown: "Unknown feature",
	},
};
